<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-card>
        <mat-card-content>
            <div class="d-flex align-items-end mb-3">
                <h1 class="fs-3 fw-light mb-0">Cancelamento em Massa</h1>
                <button mat-icon-button color="accent" class="ms-2"
                    matTooltip="Cancela em massa todos os DIOs no período informado, filtrando opcionalmente por contrato, prefixo e usuário emissor. Apenas DIOs com status passíveis de cancelamento serão afetados."
                    matTooltipPosition="right">
                    <mat-icon>info_outline</mat-icon>
                </button>
                <button mat-icon-button color="primary" class="d-print-none btn-sm ms-auto" (click)="toggleFilters = !toggleFilters">
                    <mat-icon>tune</mat-icon>
                </button>             
            </div>

            <!-- FILTROS -->
            <form class="row align-items-center" name="form" (ngSubmit)="form.valid && save(form)" #form="ngForm" novalidate>
                <ng-collapse [toggle]="true">
                    <div class="border-top px-1 py-3">
                        <div class="row align-items-end">
                            <div class="col-12 col-md-6">
                                <ng-select name="user" [items]="usuario$ | async" 
                                    placeholder="Usuário Emissor" typeToSearchText="Buscar usuário..." notFoundText="Nenhum usuário encontrado" loadingText="Buscando..."
                                    [typeahead]="usuarioInput$" [(ngModel)]="user" [compareWith]="compareWith">
                                    
                                    <!-- selected -->
                                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                        <span class="ng-value-label">{{ item.firstName }} {{ item.lastName }}</span>
                                    </ng-template>

                                    <!-- lista -->
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                        <img class="rounded-circle me-2 img-cover" width="25" height="25" [src]="item.avatarUrl || 'assets/img/default_user.jpeg'" />
                                        <span>{{ item.firstName }} {{ item.lastName }}</span>
                                    </ng-template>                                    
                                </ng-select>
                            </div>
                            <div class="col-12 col-md-6">
                                <ng-select name="contrato" [items]="contratos" bindLabel="nome"
                                    placeholder="Contrato" notFoundText="Nenhum contrato encontrado"
                                    [(ngModel)]="filters.contrato" [compareWith]="compareWith">
                                </ng-select>
                            </div>
                            <div class="col-12 col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Prefixo</mat-label>
                                    <input matInput name="prefixo" [(ngModel)]="filters.prefixo" autocomplete="off" placeholder="Ex: ABC-1234">
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="d-flex">
                                    <mat-form-field class="flex-fill me-2">
                                        <mat-label>Inicio</mat-label>
                                        <input matInput [matDatepicker]="dataInicio" name="inicio" #inicio="ngModel"
                                            autocomplete="off" [(ngModel)]="filters.dataInicio" required>
                                        <mat-datepicker-toggle matIconSuffix [for]="dataInicio"></mat-datepicker-toggle>
                                        <mat-datepicker #dataInicio></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="flex-fill">
                                        <mat-label>Fim</mat-label>
                                        <input matInput [matDatepicker]="dataFim" name="fim" #fim="ngModel" autocomplete="off"
                                            [(ngModel)]="filters.dataFim" required>
                                        <mat-datepicker-toggle matIconSuffix [for]="dataFim"></mat-datepicker-toggle>
                                        <mat-datepicker #dataFim></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>                        
                            <div class="col-12 col-md-2 ms-auto">
                                <button mat-flat-button color="primary" class="btn-lg w-100" [disabled]="form.form.invalid || loading">
                                    <mat-spinner class="btn-spinner" *ngIf="loading"></mat-spinner>
                                    <span *ngIf="!loading">CANCELAR EM MASSA</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-collapse>
            </form>     
            
        </mat-card-content>
    </mat-card>
</div>